import React from "react";
import {BsBank, BsChevronLeft, BsPerson} from "react-icons/bs";
import {formatManualPaymentDate} from "./manualPaymentModel";
import {ManualPaymentStatus} from "./ManualPaymentUI";

export function ManualPaymentTable({items, canReview, onReview}) {
  return <div className="manual-payment-table-shell">
    <table className="manual-payment-table" role="table">
      <caption className="sr-only">فهرست واریزی‌های کارت به کارت</caption>
      <thead><tr>{["شناسه", "مشتری", "عامل", "مبلغ (ریال)", "حساب مقصد", "زمان ثبت", "وضعیت", "نتیجه بررسی", ...(canReview ? ["عملیات"] : [])].map(title => <th scope="col" key={title}>{title}</th>)}</tr></thead>
      <tbody>{items.map(payment => <tr key={payment.id}>
        <td data-label="شناسه" className="manual-payment-id">#{payment.id.toLocaleString("fa-IR")}</td>
        <td data-label="مشتری" className="manual-payment-customer"><div className="manual-payment-person">
          <span className="manual-payment-avatar"><BsPerson aria-hidden="true"/></span>
          <div><strong>{payment.customer_name || "—"}</strong><small><bdi>{payment.customer_phone}</bdi></small></div>
        </div></td>
        <td data-label="عامل">{payment.submitted_by_name || "—"}</td>
        <td data-label="مبلغ (ریال)"><strong className="manual-payment-amount">{Number(payment.amount).toLocaleString("fa-IR")}</strong></td>
        <td data-label="حساب مقصد"><div className="manual-payment-destination"><BsBank aria-hidden="true"/><div>{payment.destination?.title || "—"}<small>{payment.destination?.bank_name}</small></div></div></td>
        <td data-label="زمان ثبت" className="manual-payment-date">{formatManualPaymentDate(payment.created_at)}</td>
        <td data-label="وضعیت"><ManualPaymentStatus status={payment.status}/></td>
        <td data-label="نتیجه بررسی" className="manual-payment-result">{payment.reviewed_at ? <>
          <div>{payment.reviewed_by_name || "ادمین"}</div><small>{formatManualPaymentDate(payment.reviewed_at)}</small>
          {payment.rejection_reason && <p className="manual-payment-rejection">{payment.rejection_reason}</p>}
        </> : <span className="text-app-text-muted">در انتظار بررسی ادمین</span>}</td>
        {canReview && <td data-label="عملیات" className="manual-payment-row-action"><button type="button" onClick={() => onReview(payment.id)} className={`manual-payment-button ${payment.status === "pending" ? "is-review" : ""}`} aria-label={`بررسی واریزی ${payment.id}`}>
          {payment.status === "pending" ? "بررسی" : "جزئیات"}<BsChevronLeft aria-hidden="true"/>
        </button></td>}
      </tr>)}</tbody>
    </table>
  </div>;
}
